// DONM3/services/frontend/src/components/modal.js
export class ModalComponent {
  constructor() {
    this.modalContainer = null;
    this.onCloseCallback = null;
  }

  createModalContainer() {
    // Удаляем старый контейнер, если он есть
    if (this.modalContainer) {
      this.modalContainer.remove();
    }
    
    // Создаем новый контейнер для модального окна
    this.modalContainer = document.createElement('div');
    this.modalContainer.className = 'modal-overlay';
    this.modalContainer.style.display = 'none';
    this.modalContainer.style.position = 'fixed';
    this.modalContainer.style.top = '0';
    this.modalContainer.style.left = '0';
    this.modalContainer.style.width = '100%';
    this.modalContainer.style.height = '100%';
    this.modalContainer.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    this.modalContainer.style.zIndex = '1000';
    this.modalContainer.style.display = 'flex';
    this.modalContainer.style.alignItems = 'center';
    this.modalContainer.style.justifyContent = 'center';
    this.modalContainer.style.overflow = 'auto';
    
    document.body.appendChild(this.modalContainer);
    
    // Закрытие при клике на фон
    this.modalContainer.addEventListener('click', (e) => {
      if (e.target === this.modalContainer) {
        this.closeModal();
      }
    });
    
    // Закрытие по клавише Esc
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modalContainer.style.display !== 'none') {
        this.closeModal();
      }
    });
  }

  openModal(nodeData, colors) {
    if (!this.modalContainer) {
      this.createModalContainer();
    }
    
    // Создаем содержимое модального окна
    const modalContent = document.createElement('div');
    modalContent.className = 'modal-content';
    modalContent.style.backgroundColor = 'white';
    modalContent.style.borderRadius = '8px';
    modalContent.style.maxWidth = '600px';
    modalContent.style.width = '90%';
    modalContent.style.maxHeight = '80vh';
    modalContent.style.overflow = 'auto';
    modalContent.style.padding = '1.5rem';
    modalContent.style.position = 'relative';
    modalContent.style.boxShadow = '0 5px 15px rgba(0,0,0,0.2)';
    
    // HTML содержимое модального окна
    modalContent.innerHTML = `
      <button class="modal-close-btn" style="
        position: absolute;
        top: 0.75rem;
        right: 0.75rem;
        background: none;
        border: none;
        font-size: 1.5rem;
        cursor: pointer;
        color: #6c757d;
        padding: 0.25rem;
        line-height: 1;
      ">&times;</button>
      
      <div style="display: flex; align-items: flex-start; margin-bottom: 1.25rem;">
        <div style="
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background-image: url('${nodeData.imageurl}');
          background-size: cover;
          background-position: center;
          margin-right: 1rem;
          flex-shrink: 0;
          border: 3px solid ${colors.main};
          display: flex;
          align-items: center;
          justify-content: center;
        ">
          ${!nodeData.imageurl ? `<span style="font-size: 1.5rem; font-weight: bold; color: ${colors.main};">${this.getInitials(nodeData.name)}</span>` : ''}
        </div>
        <div style="flex-grow: 1; overflow: hidden;">
          <h2 style="font-size: 1.25rem; font-weight: 600; margin-bottom: 0.25rem; color: #212529;">${nodeData.name || 'Не указано'}</h2>
          <p style="font-size: 0.9rem; color: #6c757d; line-height: 1.4;">${nodeData.position || 'Должность не указана'}</p>
        </div>
      </div>
      
      ${nodeData.department ? `<div style="margin-bottom: 1.25rem;">
        <h3 style="font-size: 0.9rem; font-weight: 600; margin-bottom: 0.5rem; color: #495057;">Подразделение</h3>
        <p style="font-size: 0.9rem; color: #212529; display: flex; align-items: center;"><span style="margin-right: 0.5rem; font-size: 1rem;">📍</span> ${nodeData.department}</p>
      </div>` : ''}
      
      ${nodeData.email || nodeData.phone ? `<div style="margin-bottom: 1.25rem;">
        <h3 style="font-size: 0.9rem; font-weight: 600; margin-bottom: 0.5rem; color: #495057;">Контакты</h3>
        ${nodeData.email ? `<p style="font-size: 0.9rem; color: #212529; margin-bottom: 0.25rem; display: flex; align-items: center;"><span style="margin-right: 0.5rem; font-size: 1rem;">✉️</span> ${nodeData.email}</p>` : ''}
        ${nodeData.phone ? `<p style="font-size: 0.9rem; color: #212529; display: flex; align-items: center;"><span style="margin-right: 0.5rem; font-size: 1rem;">📞</span> ${nodeData.phone}</p>` : ''}
      </div>` : ''}
      
      ${nodeData.biography ? `<div>
        <h3 style="font-size: 0.9rem; font-weight: 600; margin-bottom: 0.5rem; color: #495057;">Биография</h3>
        <div style="font-size: 0.9rem; color: #212529; line-height: 1.6; max-height: 300px; overflow-y: auto;">${nodeData.biography.replace(/\n/g, '<br>')}</div>
      </div>` : ''}
    `;
    
    // Добавляем содержимое в контейнер
    this.modalContainer.innerHTML = '';
    this.modalContainer.appendChild(modalContent);
    this.modalContainer.style.display = 'flex';
    
    // Добавляем обработчик для кнопки закрытия
    const closeBtn = modalContent.querySelector('.modal-close-btn');
    closeBtn.addEventListener('click', () => this.closeModal());
  }

  closeModal() {
    if (this.modalContainer) {
      this.modalContainer.style.display = 'none';
      this.modalContainer.innerHTML = '';
      if (this.onCloseCallback) {
        this.onCloseCallback();
      }
    }
  }

  setOnCloseCallback(callback) {
    this.onCloseCallback = callback;
  }

  getInitials(name) {
    if (!name) return '?';
    return name
      .split(' ')
      .slice(0, 2)
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase();
  }
}
